// @ts-nocheck
import { Plugin } from '/home/runner/work/yomua/yomua/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu',],
});

export { plugin };
